import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorGlobal } from '../reducers/notifications';
import { getAuthHeader } from '../../utils/tools';
import axios from 'axios';

export const fetchDashboardSummary = createAsyncThunk(
    'dashboard/fetchSummary',
    async (_, { dispatch }) => {
        try {
            const request = await axios.get('/api/dashboard/summary', getAuthHeader());
            return request.data;
        } catch (error) {
            dispatch(errorGlobal(error.response?.data?.message ?? 'Nepodarilo sa načítať prehľad'));
            throw error;
        }
    }
);

export const fetchWasteByBranch = createAsyncThunk(
    'dashboard/fetchWasteByBranch',
    async (year, { dispatch }) => {
        try {
            const request = await axios.get('/api/charts/waste-by-branch', {
                params: { year },
                ...getAuthHeader()
            });
            return request.data;
        } catch (error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            throw error;
        }
    }
);

export const fetchWasteByLoadingCode = createAsyncThunk(
    'dashboard/fetchWasteByLoadingCode',
    async ({ year, branchId }, { dispatch }) => {
        try {
            const request = await axios.get('/api/charts/waste-by-loading-code', {
                params: { year, ...(branchId && { branchId }) },
                ...getAuthHeader()
            });
            return request.data;
        } catch (error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            throw error;
        }
    }
);

export const fetchWasteByCode = createAsyncThunk(
    'dashboard/fetchWasteByCode',
    async ({ year, branchId }, { dispatch }) => {
        try {
            const request = await axios.get('/api/charts/waste-by-code', {
                params: { year, ...(branchId && { branchId }) },
                ...getAuthHeader()
            });
            return request.data;
        } catch (error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            throw error;
        }
    }
);

export const fetchMonthlyWaste = createAsyncThunk(
    'dashboard/fetchMonthlyWaste',
    async ({ year, branchId }, { dispatch }) => {
        try {
            const request = await axios.get('/api/charts/monthly-waste', {
                params: { year, ...(branchId && { branchId }) },
                ...getAuthHeader()
            });
            return request.data;
        } catch (error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            throw error;
        }
    }
);
